<template>
	<div v-html="highlightedText"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
	defineProps<{
		text: string
		keyword: string
	}>(),
	{
		text: '',
		keyword: ''
	}
)

const highlightedText = computed(() => {
	const escapedKeyword = props.keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	const regex = new RegExp(`(${escapedKeyword})`, 'gi')
	return props.text.replace(regex, '<span style="color: #bd3a36">$1</span>')
})
</script>
